const SID = /^[A-Za-z0-9._:@-]{1,128}$/;

export default function tokenSidOf(token: string | null): string | null {
    if (!token) return null;
    const part = token.split('.')[1];
    if (!part) return null;
    try {
        const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
        const sid = (JSON.parse(json) as { sid?: unknown }).sid;
        return typeof sid === 'string' && SID.test(sid) ? sid : null;
    } catch {
        return null;
    }
}
